function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var module; // LICENSE_CODE ZON

'use strict';
/*jslint node:true, react:true*/


var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', 'react-dom', 'virt_jquery_all', '/www/hola/pub/react_util.js', 'classnames'], function (React, ReactDOM, $, react_util, cn) {
  var E = {};
  const useState = React.useState,
        useEffect = React.useEffect,
        Fragment = React.Fragment,
        useRef = React.useRef,
        useMemo = React.useMemo;

  const Modal = props => {
    const _useState = useState(props.show),
          _useState2 = _slicedToArray(_useState, 2),
          show = _useState2[0],
          set_show = _useState2[1];

    const state = useMemo(() => ({}), []);
    const ref_root = useRef(null);

    const dom_in = () => {
      if (state.dom) {
        state.dom.style.display = 'block';
        state.dom.style.paddingLeft = '0px';
        const body = document.body;
        body.classList.add('modal-open');
        setTimeout(() => {
          state.dom.classList.add('in');
        }, 200);
      }
    };

    useEffect(() => {
      if (props.show != show) set_show(props.show);
      const body = document.body;
      if (props.show) dom_in();else {
        if (state.dom) state.dom.classList.remove('in');
        setTimeout(() => {
          body.classList.remove('modal-open');
        }, 0);
      }
    }, [props.show]);

    const on_back_click = event => {
      if (props.backdrop === true) props.on_close();else event.stopPropagation();
    };

    useEffect(() => {
      const on_close_hdl = () => props.on_close();

      const on_keyboard = event => {
        if (event.keyCode == 27 && props.keyboard !== false) props.on_close();
      };

      if (ref_root && ref_root.current) {
        const dom = ref_root.current;
        dom.addEventListener('modal_close', on_close_hdl);
        document.addEventListener('keydown', on_keyboard);
        state.dom = dom;
        if (props.show) dom_in();
        return () => {
          dom.removeEventListener('modal_close', on_close_hdl);
          document.removeEventListener('keydown', on_keyboard);
        };
      }
    }, []);
    return /*#__PURE__*/React.createElement(Fragment, null, props.backdrop && /*#__PURE__*/React.createElement("div", {
      className: "modal-backdrop fade in"
    }), /*#__PURE__*/React.createElement("div", {
      className: cn(props.cls, 'modal fade'),
      tabIndex: -1,
      onClick: on_back_click,
      ref: ref_root
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-dialog",
      onClick: event => event.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-content"
    }, props.children))));
  };

  const Header = props => {
    const send_close = ev => {
      ev.target.dispatchEvent(new Event('modal_close', {
        bubbles: true
      }));
    };

    const label = '×';
    return /*#__PURE__*/React.createElement("div", {
      className: "modal-header"
    }, props.close_button && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close",
      onClick: send_close
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Close")), props.children);
  };

  class Iframe_modal extends React.PureComponent {
    constructor(...props) {
      super(...props); // XXX sergey: shold be different for different modals

      this._id = 'iframe_modal';

      for (var _i2 = 0, _arr2 = ['show', 'close']; _i2 < _arr2.length; _i2++) {
        let k = _arr2[_i2];
        this[k] = this[k].bind(this);
      }
    }

    componentDidMount() {
      var _this$_form;

      (_this$_form = this._form) === null || _this$_form === void 0 ? void 0 : _this$_form.submit();
    }

    show() {
      this.setState({
        show: true
      });
    }

    close() {
      this.setState({
        show: false
      });
      if (this.props.on_close) this.props.on_close();
    }

    get_form() {
      if (!this.props.form) return null;
      const _this$props$form = this.props.form,
            action = _this$props$form.action,
            method = _this$props$form.method,
            data = _this$props$form.data;
      const inputs = Object.keys(data).map(f => /*#__PURE__*/React.createElement("input", {
        key: f,
        type: "hidden",
        name: f,
        value: data[f]
      }));
      return /*#__PURE__*/React.createElement("form", {
        ref: _ref => {
          this._form = _ref;
        },
        target: this._id,
        action: action,
        method: method
      }, inputs);
    }

    render() {
      const props = this.props,
            _id = this._id;
      return /*#__PURE__*/React.createElement(Modal, {
        on_close: this.close,
        show: this.show,
        backdrop: props.no_bg_close ? 'static' : true,
        keyboard: props.no_kb_close ? false : true
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, this.get_form(), /*#__PURE__*/React.createElement("iframe", {
        frameBorder: "0",
        height: props.height || '100%',
        width: "100%",
        id: _id,
        name: _id,
        scrolling: "no",
        src: props.url
      })));
    }

  }

  const open_remote_modal = opt => {
    let el = document.createElement('div');
    el.className = 'remote-modal-root';
    document.body.appendChild(el);
    const win_height = window.innerHeight;
    const height = Math.min(640, win_height);

    const close = () => {
      ReactDOM.unmountComponentAtNode(el);
      el.remove();
    };

    const on_close = () => {
      if (opt.on_cancel) opt.on_cancel(); // with delay to let modal to finish the close animation

      setTimeout(close, 500);
    };

    react_util.dom_render( /*#__PURE__*/React.createElement(Iframe_modal, _extends({
      on_close: on_close,
      height: height
    }, opt)), el);
    return {
      close
    };
  };

  E = {
    open_remote_modal,
    Modal,
    Header
  };
  return E;
});